import { Controller, useForm } from "react-hook-form";
import { ButtonCommon } from "../../../../../Layout/styled";
import {
  LiveStakeContainer,
  StakeForm,
  StakeFormBody,
  StakeFormHeader,
} from "./styled";
import InputCommon from "../../../../../components/Common/Input";
import { useContext, useEffect, useState } from "react";
import web3 from "web3";
import { ethers } from "ethers";
import { useAppKitAccount } from "@reown/appkit/react";
import ABI_STAKING from "../../../../../constant/ABI/abiStaking.json";
import toast from "react-hot-toast";
import { convertFromWei, convertToWei } from "../../../../../utils/convertNumber";
import getTokenInfo from "../../../../../utils/checkInfoByAccount";
import { ContextProviderWrapper } from "../../../../../components/Context";
import Value from "../../../../../components/Value";
import Loading from "../../../../../components/Loading";

type FormValuesProps = {
  value: string;
};

const LiveStake = ({
  displayData,
  clickedId,
  setOpenStake,
  openStake,
  handleGetSchedule,
  fetchUserProfile,
  fetchPrices,
}: any) => {
  const { theme }: any = useContext(ContextProviderWrapper);
  const Web3 = new web3(window.ethereum);
  const { address }: any = useAppKitAccount();
  const [pendingApprove, setPendingApprove] = useState<any>(false);
  const [decimals, setDecimals] = useState<any>("18");
  const [allowance, setAllowance] = useState<any>("0");
  const [balanceToken, setBalanceToken]: any = useState("0");

  const defaultValues = {
    value: "",
  };

  const [isLoading, setIsLoading] = useState(false);
  const methods = useForm<FormValuesProps>({
    defaultValues,
    mode: "onChange",
  });

  const { control, watch, setValue } = methods;
  const valueInput = watch("value");

  const getDataToken = async (contract: any, token: any) => {
    try {
      const amountAllowance = await getTokenInfo(contract, token, address);
      setAllowance(amountAllowance.allowance);
      setDecimals(amountAllowance.decimals);
      setBalanceToken(amountAllowance.balanceOf);
    } catch (error) {
      console.error("error", error);
    }
  };

  useEffect(() => {
    if (clickedId > 0 && address) {
      getDataToken(
        displayData[clickedId - 1]?.contract,
        displayData[clickedId - 1]?.tokenStake
      );
    }
  }, [clickedId, address]);

  const approvePoolStaking = async () => {
    setPendingApprove(true);
    const gasPrice = await Web3.eth.getGasPrice();
    try {
      const contract = new Web3.eth.Contract(
        ABI_STAKING,
        displayData[clickedId - 1]?.tokenStake
      );
      await contract.methods
        .approve(
          displayData[clickedId - 1]?.contract,
          ethers.MaxUint256.toString()
        )
        .send({ from: address, gasPrice: gasPrice.toString() })
        .then(async () => {
          setPendingApprove(false);
          await getDataToken(
            displayData[clickedId - 1]?.contract,
            displayData[clickedId - 1]?.tokenStake
          );
        })
        .catch((err: any) => {
          console.error("Err approve", err);
          toast.error(err.message);
          setPendingApprove(false);
        });
    } catch (error: any) {
      console.error("Err approve", error);
      toast.error(error.message);
      setPendingApprove(false);
    }
  };

  const handleStaking = async () => {
    setIsLoading(true);
    if (typeof window !== "undefined" && window.ethereum) {
      const contractStake = new Web3.eth.Contract(
        ABI_STAKING,
        displayData[clickedId - 1].contract
      );
      const gasPrice = await Web3.eth.getGasPrice();
      const convertAmount: any = convertToWei(valueInput, decimals);
      try {
        await contractStake.methods
          .deposit(convertAmount)
          .send({
            from: address,
            gasPrice: gasPrice.toString(),
          })
          .then(async (res: any) => {
            if (res) {
              await fetchUserProfile();
              await fetchPrices();
              await handleGetSchedule();
              await getDataToken(
                displayData[clickedId - 1]?.contract,
                displayData[clickedId - 1]?.tokenStake
              );
              setIsLoading(false);
              setOpenStake(false);
              toast.success("Stake successfully");
            }
          })
          .catch((error: any) => {
            toast.error(error.message);
            setIsLoading(false);
          });
      } catch (error: any) {
        toast.error(error.message);
        setIsLoading(false);
      }
    }
  };

  const handleMaxValue = async () => {
    setValue("value", balanceToken.toString());
  };

  useEffect(() => {
    if (!openStake) {
      setValue("value", "");
    }
  }, [openStake]);
  return (
    <LiveStakeContainer>
      <StakeForm className={theme}>
        <StakeFormHeader className={theme}>
          <p>Amount</p>
          <div>
            <p>
              Balance: <Value value={Number(balanceToken)} />
            </p>
            <button
              disabled={isLoading}
              onClick={() => {
                handleMaxValue();
              }}
            >
              MAX
            </button>
          </div>
        </StakeFormHeader>
        <StakeFormBody className={theme}>
          <Controller
            name="value"
            control={control}
            render={({ field }: any) => (
              <InputCommon
                {...field}
                placeHolder="0.00"
                name="search"
                type="number"
                onChange={(e: any) =>
                  !isLoading && field.onChange(e.target.value)
                }
              />
            )}
          />
        </StakeFormBody>
      </StakeForm>
      {Number(valueInput) > Number(allowance) ? (
        <ButtonCommon
          disabled={pendingApprove}
          onClick={() => {
            approvePoolStaking();
          }}
        >
          <Loading status={pendingApprove} title="Approve" />
        </ButtonCommon>
      ) : (
        <ButtonCommon
          onClick={() => {
            handleStaking();
          }}
          disabled={
            Number(valueInput) <= 0 ||
            !Number(valueInput) ||
            isLoading ||
            Number(balanceToken) < Number(valueInput)
          }
        >
          <Loading status={isLoading} title="Stake" />
        </ButtonCommon>
      )}
    </LiveStakeContainer>
  );
};

export default LiveStake;
